module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 23
// module chunks = 0